import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";

const styles = createUseStyles((theme) => ({
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  unsavedChangesModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex",
        },
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px",
      },
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: "8px 24px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    },
  },
  unsavedChangesModalWrapper: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  btnContainer: {
    marginTop: "32px",
    marginBottom: "16px",
  },
  cancelBtn: {
    height: "100%",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px",
    fontFamily: theme.fontFamily,
  },
  leaveBtn: {
    height: "100%",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px",
    fontFamily: theme.fontFamily,
  },
  colCancel: {
    padding: "0px",
    marginRight: "6px",
  },
  colLeave: {
    padding: "0px",
    marginLeft: "6px",
  },
}));

export default styles;
